import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { featuredIcon, featuredIconWrapper } from "./FeaturedIcon.css.js";
import { jsx as _jsx } from "react/jsx-runtime";
const BaseFeaturedIcon = (t0, ref) => {
  const $ = _c(14);
  const {
    icon: Icon,
    size: t1,
    theme: t2,
    color: t3
  } = t0;
  const size = t1 === undefined ? "l" : t1;
  const theme = t2 === undefined ? "lightCircle" : t2;
  const color = t3 === undefined ? "primary" : t3;
  let t4;
  if ($[0] !== color || $[1] !== size || $[2] !== theme) {
    t4 = featuredIconWrapper({
      theme,
      size,
      color
    });
    $[0] = color;
    $[1] = size;
    $[2] = theme;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== color || $[5] !== size) {
    t5 = featuredIcon({
      size,
      color
    });
    $[4] = color;
    $[5] = size;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== Icon || $[8] !== t5) {
    t6 = /*#__PURE__*/_jsx(Icon, {
      className: t5
    });
    $[7] = Icon;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== ref || $[11] !== t4 || $[12] !== t6) {
    t7 = /*#__PURE__*/_jsx("div", {
      ref: ref,
      className: t4,
      "aria-hidden": true,
      role: "graphics-symbol",
      children: t6
    });
    $[10] = ref;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
export const FeaturedIcon = /*#__PURE__*/React.forwardRef(BaseFeaturedIcon);
//# sourceMappingURL=FeaturedIcon.js.map